///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { times } from "lodash";

function Loader() {
  return (
    <div className="one-whole" data-testid="loader">
      {times(10, index => {
        return (
          <div
            key={index}
            className="grid one-whole content-placeholder bg-white py-16 pl-36 pr-20 mb-8 full-height flex"
          >
            <div className="grid-cell inline-block">
              <span
                style={{ width: 36, height: 36, borderRadius: "50%" }}
                className="inline-block round"
              ></span>
            </div>
            <div className="grid-cell t90 inline-block pl-16">
              <span style={{ width: 700 }} className="mb-12"></span>
              <span style={{ width: 350 }}></span>
            </div>
            <div className="grid__cell fr flex">
              <span style={{ width: 50 }}></span>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Loader;
